import { MenuService } from './../../services/menu.service';
import { NotificationService } from './../../services/notification.service';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonService } from 'app/services/common.service';
import { RouteDataService } from './../../services/route-data.service';
import { Subscription, Observable } from 'rxjs';
import { Component, HostBinding, OnInit, ViewChild, OnDestroy, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../services/login.service';

@Component({
  selector: 'app-coach-menu',
  templateUrl: './coach-menu.component.html',
  styleUrls: ['./coach-menu.component.scss']
})
export class CoachMenuComponent implements OnInit, OnDestroy {
  routerList: Observable<Array<any>>;
  partnerId: any;
  menuMessageCount = 0;
  menuAssignmentCount = 0;
  menuStudentCount = 0;
  menuEssayCount = 0;
  assignmentManagerCount = 0;
  menuScroll = false;
  pinMenuBar: boolean;
  subscription: Subscription[] = [];
  refreshInterval: any;
  @ViewChild('sidemenu') sideMenu;
  @HostBinding('class.ns-navigation-collapsed') navigationCollapsed = true;

  constructor(
    private routeDataService: RouteDataService,
    private commonService: CommonService,
    private _commonDataSharedService: CommonDataSharedService,
    public _router: Router,
    private _commonRequestResponseService: CommonRequestResponseService,
    private _loginService: LoginService,
    private notificationService: NotificationService,
    private _menuService: MenuService,
    private renderer: Renderer2
  ) {

  }

  ngOnInit() {
    this.navigationCollapsed = true;
     if (JSON.parse(localStorage.getItem('toggleMenu'))) {
      this.pinMenuBar = JSON.parse(localStorage.getItem('toggleMenu'));
      this.navigationCollapsed = false;
      this.menuScroll = false;
      this.renderer.addClass(document.body, 'menu-open');
    }

    this.subscription.push(
      this._commonDataSharedService.collapseMenu.subscribe((data: any) => {
        this.navigationCollapsed = this.pinMenuBar ? false : true;
      }),
      // this._commonDataSharedService.updateMessageCount.subscribe((value: any) => {
      //   this.getCountValue();
      // })
    );
    const routeParam = this._router.url.split('/').pop();
    this._commonDataSharedService.sidemenu.next(this.sideMenu);

    this.routeDataService.coachMenuRouteData.subscribe((data: any) => {
      this.updateMenu(data, routeParam)
    });
    this.refreshInterval = setInterval(() => {
      this.getCountValue();
    }, 60 * 1000);
    this.getCountValue();
  }

  pinMenu(event) {
    event.stopPropagation()
    this.pinMenuBar = !this.pinMenuBar;
    localStorage.setItem('toggleMenu', this.pinMenuBar.toString())
    if (this.pinMenuBar) {
      this.navigationCollapsed = false;
      this.renderer.addClass(document.body, 'menu-open');
    } else {
      this.navigationCollapsed = true;
      this.renderer.removeClass(document.body, 'menu-open');
    }
  }

  updateMenu(data, routeParam: any) {
    this.routerList = data;
    const selectMenu = this.commonService.checkParentExist(this.routerList, { path: routeParam });
    if (selectMenu.mainIndex > -1) {

      this.commonService.toggleSideMenu(this.routerList, this.routerList[selectMenu.mainIndex])
      this._menuService.selectMenu(this.routerList, { path: routeParam })
    }
  }

  getCountValue() {
    this._commonRequestResponseService.getCountData()
      .subscribe(
        (data: any) => {
          this.menuMessageCount = data.messagesCount;
          this.menuAssignmentCount = data.assignmentCount;
          this.menuStudentCount = data.myStudentCount;
          this.menuEssayCount = data.essaysCount;
          this.assignmentManagerCount = data.assignmentManagerCount;
          this._commonDataSharedService.countUpdate.next(data);
        },
        () => {
          this.notificationService.show('error', 'Error while calling service');
        });
  }

  onCoachMenuRouteClick(route, toggleFlag) {
    localStorage.removeItem('searchResult')
    if (JSON.parse(localStorage.getItem('toggleMenu'))) {
      this.pinMenuBar = JSON.parse(localStorage.getItem('toggleMenu'));
      this.navigationCollapsed = false;
      this.menuScroll = false;
      this.renderer.addClass(document.body, 'menu-open');
    }
    if (!this.pinMenuBar) {
      this.renderer.removeClass(document.body, 'menu-open');
      this.navigationCollapsed = true;
      this.menuScroll = false;
    }
    if (toggleFlag) {
      this.commonService.toggleSideMenu(this.routerList, route);
    }
    if (route.innerItems.length <= 0) {
      this.commonService.setBreadCrumb(route, this.routerList, 'coach');
      this._menuService.setCurrentRouteData(route);
      this._menuService.selectMenu(this.routerList, route);

      this.routeDataService.setCoachMenuRoute.next('./../' + route.moduleName.toLowerCase().trim() + '/' + route.path);
    }
  }

  logout() {
    this.renderer.removeClass(document.body, 'menu-open');
    this._loginService.logout();
  }

  toggleNavigationCollapse() {
    if (this.pinMenuBar && this.navigationCollapsed) {
      this.renderer.addClass(document.body, 'menu-open');
    }
    else if (!this.pinMenuBar && this.navigationCollapsed) {
      this.renderer.addClass(document.body, 'menu-open');
    }
    else {
      this.renderer.removeClass(document.body, 'menu-open');
    }
    this.navigationCollapsed = !this.navigationCollapsed;
    this.menuScroll = !this.menuScroll;
  }

  toggleNavigationCollapseMobile(shouldCollapseMenu = true) {
    if ((window.innerWidth) < 980 && shouldCollapseMenu) {
      this.navigationCollapsed = !this.navigationCollapsed;
    }
  }

  routeHasChildren(route) {
    return route.innerItems.filter((item) => item.access === 'true').length > 0;
  }

  ngOnDestroy() {
    this.subscription.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
    clearInterval(this.refreshInterval);
  }
}
